module.exports = __webpack_public_path__ + "img/7.59d2b6d8.jpg";